import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHeadersService } from '@service/rest/headers/http-headers.service';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {

    constructor(private httpHeadersService: HttpHeadersService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let newRequest: HttpRequest<any>;
        let newHeaders = request.headers;
        newHeaders = newHeaders
            .set('App-Version', this.httpHeadersService.generateAppVersion())
            .set('Device-Language', this.httpHeadersService.generateDeviceLanguage())
            .set('Device-Name', this.httpHeadersService.generateDeviceName())
            .set('Device-OS', this.httpHeadersService.generateDeviceOs())
            .set('Device-ID', this.httpHeadersService.generateDeviceId());
        newRequest = request.clone({
            headers: newHeaders
        });

        return next.handle(newRequest);
    }
}
